import { listRequestedMessages } from 'controllers/SocialServiceController'
import { listSongsAndVideo } from 'controllers/SocialServiceController'
import { store } from 'index'
import { setAllowSwipe } from 'redux/actions/displayActions'
import { setPlayList } from 'redux/actions/messagesActions'
import { setFetchInProgress } from 'redux/actions/fetchActions'
import { setEndOfMessages } from 'redux/actions/messagesActions'
import { setFetchStart } from 'redux/actions/fetchActions'
import { buildNewPlaylistEntries } from './playlistUtils'
import { CATEGORY_MODES } from 'redux/reducers/harmonizeReducer'
import { setMessages } from 'redux/actions/messagesActions'
import { setCategoryMode } from 'redux/actions/fetchActions'

/**
 * Take the Messages, build new Playlist entries and update the playList.
 * The messages store is also updated.
 * @param {*} songs     Messages
 * @param {*} dispatch 
 */
export const buildAndSetPlaylist = (songs, actualCategoryMode, dispatch) => {
    const { messages, playList } = store.getState().messages
    const { fetchStart } = store.getState().fetch
    const result = buildNewPlaylistEntries(songs)
    const blockSize = parseInt(process.env.REACT_APP_FETCH_BLOCK_SIZE)
    if (result.length < blockSize) {
        console.log('(*) HarmonizeHome END OF MESSAGES')
        dispatch(setEndOfMessages(true))
    }
    if (fetchStart > 0) {
        dispatch(setMessages([...messages, ...songs]))
        dispatch(setPlayList([...playList, ...result]))
    } else {
        dispatch(setMessages(songs))
        dispatch(setPlayList(result))
    }

    console.log(`buildAndSetPlaylist received ${result.length} entries new playList length ${playList.length + result.length}`)
    dispatch(setFetchInProgress(false))
    dispatch(setCategoryMode(actualCategoryMode))
}

export const fetchSongsAndVideo = async (dispatch, resetCategoryMode = CATEGORY_MODES.ALL_MEDIA,
    fetchSize = process.env.REACT_APP_FETCH_BLOCK_SIZE) => {
    const { categoryMode, fetchStart, fetchInProgress, query } = store.getState().fetch
    console.log(`fetchSongsAndVideo categoryMode ${categoryMode ? categoryMode.type : 'undefined'}, 
        fetchStart ${fetchStart}, 
        fetchSize ${fetchSize},
        fetchInProgress ${fetchInProgress}, 
        query ${JSON.stringify(query)}`)
    let actualCategoryMode = categoryMode
    if (categoryMode.type === CATEGORY_MODES.RESET.type) {
        actualCategoryMode = resetCategoryMode
        console.log(`fetchSongsAndVideo reset categoryMode to ${actualCategoryMode.type}`)
    }

    if (fetchStart === -1) {
        dispatch(setFetchStart(0))
        dispatch(setEndOfMessages(false))
    } else if (!fetchInProgress) {
        dispatch(setFetchInProgress(true))
        dispatch(setAllowSwipe(true))
        let songs
        if (query) {
            songs = await listRequestedMessages(query, fetchStart, fetchSize)
        } else {
            songs = await listSongsAndVideo(actualCategoryMode, fetchStart, fetchSize)
        }
        buildAndSetPlaylist(songs, actualCategoryMode, dispatch)
    }
}